import React from "react";
import IndustriesBannerImage from "../../images/excutive-compass-image-1.png";
import IndustriesBannerImage1 from "../../images/Hero-Banner-Logistics-1.jpg";
import SegmentSliderImage1 from "../../images/Transportation.jpg";
import SegmentSliderImage2 from "../../images/Fleet-Management.jpg";
import SegmentSliderImage3 from "../../images/Logistics.jpg";

import IconLastmileDeliveryPlatform from "../../icons/icon-last-mile-delivery-platform.svg";
import IconSalesMarketingAutomationPlatform from "../../icons/CRM.svg";
import IconEnterpriseB2CeCommerce from "../../icons/icon-Enterprise-B2C-eCommerce.svg";
import IconIndustrialIOTPlatform from "../../icons/icon-industrial-IOT-platform.svg";

import ImagePredictHandleSCMDelays from "../../images/Predict-Handle-SCM-Delays.jpg";
import ImagePredictivePackageSortingRouting from "../../images/Predictive-Package-Sorting-And-Routing.jpg";
import ImageInventoryWarehouseAutomation from "../../images/Inventory-Warehouse-Automation.jpg";
import ImageIntelligentResilientSupplyChain from "../../images/Intelligent-Resilient-Supply-Chain.jpg";
import ImageSupplierIntelligence from "../../images/Supplier-Intelligence.jpg";

import ImageUseCase1 from "../../images/Connected-Fleet.jpg";
import ImageUseCase2 from "../../images/Visual-Supply-Chain-Network.jpg";
import ImageUseCase3 from "../../images/Delivery-Experiences.jpg";
import ImageUseCase4 from "../../images/Industry-Digital-Twin.jpg";
import ImageUseCase5 from "../../images/Paper-Less-Operations.jpg";
import ImageUseCase6 from "../../images/Robotic-Process-Automations1.jpg";

import IconDataAnalytics from "../../icons/icon-retail-data-analytics.svg";
import IconEnterpriseIntegrations from "../../icons/icon-retail-enterprise-integrations.svg";
import IconCloudEnablement from "../../icons/icon-retail-cloud-enablement.svg";
import IconDigitalStrategy from "../../icons/icon-transformation-strategy-roadmap-ps.svg";
import IconDigitalExperiences from "../../icons/icon-retail-digital-experiences.svg";
import IconDigitalTransformation from "../../icons/icon-retail-digital-transformation.svg";

import ImageCSslider1 from "../../images/POD-CS.jpg";

import ImageBlogImage1 from "../../images/logistic-blog-img-1.jpg";
import ImageBlogImage2 from "../../images/logistic-blog-img-2.jpg";


export const mainBannerObj = {
  classes: "industries-banner industries-manifacturing-banner",
  title: "Retail Industries",
  mediaType: "image",
  mediaSource: IndustriesBannerImage,
  mediaClass: "",
  imagetitle: "Improved Logistics",
  imagealt: "Improved Logistics",
  bannerItems: [
    {
      subheader:"2022 EXECUTIVE COMPASS",
      header: (<>Must-Know Trends for Supply Chain & Manufacturing - 2022</>),
      content: <>A no-nonsense, research-backed “EXECUTIVE COMPASS” that provides you comprehensive insights and monetization ideas about digital manufacturing & resilient supply chains.</>,
      buttonText:"Download",
      link: "/executive-compass/supply-chain-manufacturing-infographic-2022/",
    },
    {
      subheader:"strategy",
      header: (<>Improving your <br /> logistics to increase <br />customer loyalty</>),
      content: <>Discover how improving your logistics strategy will increase <br/> customer loyalty?</>,
      buttonText:"Read More",
      link: "/blog/improve-logistics-strategy-customer-loyalty/",
    }
  ],

  bannerSliderImageItems: [
    {
      image: IndustriesBannerImage,
      imagetitle: "Infographic Supply Chains 4.0",
      imagealt: "Infographic Supply Chains 4.0",
    },
    {
      image: IndustriesBannerImage1,
      imagetitle: "Industries Logistics",
      imagealt: "Industries Logistics",
    },
  ]
};

export const pageIntroObj = {
  classes: "section-gap retail-intro",
  title: "Embracing the digital disruption",
  header: (<>Get better control, visibility, and savings across the entire <br /> logistics value chain with digital platforms and AI.</>),
  content: (<><p>50% of the enterprises supply chains faced significant disruptions due to COVID-19. 33% of them face major disruptions almost every 3 years due to pandemics, natural disasters, trade wars, and geopolitical issues. Manufacturers who lacked digital capabilities to visualize and trace their supply chains, identify issues and address them with insights had to take massive hits on productions and profits.</p>
    
    <p>With the rise of e-commerce, 80% of consumers will switch brands if their goods aren’t delivered on time, which puts tremendous pressure on businesses to improve their OTIF performance and SLAs.</p>

    <p>At Rapidops,  we partner with global brands to rethink and reshape their logistics with advanced digital transformation, innovation, and automation. We help our clients leverage the power of IIOT, Industry 4.0, digital twins, and analytics to help them create traceable & resilient supply chains, improve shipping processes, automate business operations, and deliver outstanding customer experiences.</p></>)
};

export const industrySegmentsObj = {
  classes: "section-gap industry-segment",
  title: "LOGISTICS industry",
  header: (<>Industry Segments</>),
  content: (<><p>Unleash the full potential of Cloud, Data and AI to empower employees, engage customers <br /> and optimize business operations.</p></>),
  segmentSliderItems: [
    {
      image: SegmentSliderImage1,
      imagetitle: "Transportation",
      imagealt: "Transportation",
      header: (<>Transportation</>),
      content: <>Harness the power of digital transformation to deploy smarter, safer and more efficient services.</>,
    },
    {
      image: SegmentSliderImage2,
      imagetitle: "Fleet Management",
      imagealt: "Fleet Management",
      header: (<>Fleet Management</>),
      content: <>Increase vehicle uptime and enhance customer service with smart, connected fleet management solutions.</>,
    },
    {
      image: SegmentSliderImage3,
      imagetitle: "Logistics",
      imagealt: "Logistics",
      header: (<>Logistics</>),
      content: <>Leverage IoT, machine learning and predictive analytics for optimizing logistics operations.</>,
    },
  ]
};

export const threeColSliderObj = {
  classes: "retail-solution",
  header: <>Logistics 4.0 Products</>,
  content: <>Our products help organizations discover precisely where and how they can maximize their operational resilience<br /> and unlock opportunities for reimagination with intelligence, insights, and automation.</>,
  items: [
    {
      icon: <IconLastmileDeliveryPlatform />,
      subHeader: "rapidDELIVERY",
      header: "Multi-channel last-mile delivery platform",
      content: "Seamlessly deliver products at your customer’s doorstep with an end-to-end fulfillment and delivery solution."
    }, {
      icon: <IconSalesMarketingAutomationPlatform />,
      subHeader: "Customer Data Platform (CDP)",
      header: "Sales and marketing automation platform",
      content: "Deliver personalized sales and marketing experiences to your customers with an award-winning customer management and engagement platform."
    }, {
      icon: <IconEnterpriseB2CeCommerce />,
      subHeader: "rapidCOMMERCE",
      header: "Direct-to-customer eCommerce for B2C & B2B",
      content: "Create the right platforms and digital products to create exceptional customer experiences and maximize ROI."
    }, {
      icon: <IconIndustrialIOTPlatform />,
      subHeader: "rapidIIOT",
      header: "Industrial IOT platform powered by AI",
      content: "Leverage AI to gain insights on industrial processes & boost your enterprise to Industry 4.0 and beyond."
    }
  ]
};


export const industryLogisticAIObj = {
  title: "Logistics AI",
  content: "Reimagine industrial logistics and supply-chains with AI and IoT",
  tabItems: [
    {
      header: "Predict & Handle SCM delays",
    }, {
      header: "Predictive Package Sorting & Routing",
    }, {
      header: "Inventory & Warehouse Automation",
    }, {
      header: "Intelligent & Resilient Supply Chain",
    }, {
      header: "Supplier Intelligence",
    }
  ],
  
  serviceMediaOne: [
    {
      source: ImagePredictHandleSCMDelays,
      imagetitle: "Predict & Handle SCM delays",
      imagealt: "Predict & Handle SCM delays",
      content: "Reduce downtime, delays & exceptions with real-time insights and improve the accuracy of the actions with reinforcement learning.",
    }
  ],
  serviceMediaTwo: [
    {
      source: ImagePredictivePackageSortingRouting,
      imagetitle:"Predictive Package Sorting and Routing",
      imagelat:"Predictive Package Sorting and Routing",
      content: "Use intelligence to transform your warehouse ops. Optimize the routing and sorting decisions using IOT, data, and AI-powered routing engines.",
    }
  ],
  serviceMediaThree: [
    {
      source: ImageInventoryWarehouseAutomation,
      imagetitle:"Inventory and Warehouse Automation",
      imagelat:"Inventory and Warehouse Automation",
      content: "Optimize and automate the inventory stock levels and re-orders based on the actual demand and consumption patterns to save millions of capital expenses while ensuring continuity of production.",
    },
  ],
  serviceMediaFour: [
    {
      source: ImageIntelligentResilientSupplyChain,
      imagetitle:"Intelligent and Resilient Supply Chain",
      imagelat:"Intelligent and Resilient Supply Chain",
      content: "Bring visibility and traceability to your supply chains. Identify new opportunities to reduce costs, improve service levels, make better sourcing decisions and minimize the time required to deliver finished products.",
    },
  ],
  serviceMediaFive: [
    {
      source: ImageSupplierIntelligence,
      imagetitle:"Supplier Intelligence",
      imagelat:"Supplier Intelligence",
      content: "Improve supplier performance, reliability, and resiliency by monitoring their costs, quality, risks, delivery, dependencies, conditions, SLAs, and much more.",
    },
  ]
};


export const useCaseObj = {
  classes: "reatail-usecase",
  header: (<>Solutions</>),
  content: (<><p>How our solutions help providers lead the digital disruption?</p></>),
  useCaseItems: [
    {
      image: ImageUseCase1,
      imagetitle: "Connected Fleet ",
      imagealt: "Connected Fleet ",
      title: (<>Connected Fleet </>),
      content: <>Monitor, analyze, automate, and manage your large-scale connected fleets more efficiently. Gain better fleet visibility and effective data collection and realize improved ROI.</>,
    },
    {
      image: ImageUseCase2,
      imagetitle: "Visual Supply Chain Network",
      imagealt: "Visual Supply Chain Network",
      title: (<>Visual Supply Chain Network</>),
      content: <>Create connected products and expriences for improving productivity and communication at supply chain operations of all sizes.</>,
    },
    {
      image: ImageUseCase3,
      imagetitle: "Delivery Experiences",
      imagealt: "Delivery Experiences",
      title: (<>Delivery Experiences</>),
      content: <>Improve product delivery experiences and performance with a fully digitized solution to automate order processing, shipment planning, and real-time delivery management.</>,
    },
    {
      image: ImageUseCase4,
      imagetitle: "Industry 4.0 Digital Twin",
      imagealt: "Industry 4.0 Digital Twin",
      title: (<>Industry 4.0 Digital Twin</>),
      content: <>Build virtual instances of physical operations, processes, and products to gain resilience and optimize business performance.</>,
    },
    {
      image: ImageUseCase5,
      imagetitle: "Paper-less Operations",
      imagealt: "Paper-less Operations",
      title: (<>Paper-less Operations</>),
      content: <>With a streamlined process, reduced paperwork, and better access to information, improve productivity and business profitability. </>,
    },
    {
      image: ImageUseCase6,
      imagetitle: "Robotic Process Automation",
      imagealt: "Robotic Process Automation",
      title: (<>Robotic Process Automation</>),
      content: <>Achieve significant operational efficiency, business agility and greater responsiveness to change through Robotic Process Automation.</>,
    },
  ]
};

export const gridlayoutObj = {
  classes: "two-row-three-col-grid",
  header: "Services",
  subHeader: "How we help the logistics and supply-chain providers lead the digital disruption?",
  gridItems: [
    {
      icon: <IconDataAnalytics />,
      header: "Data Analytics",
      content: "Deliver rich data-driven insights and experiences across products and customers with analytics and AI"
    },
    {
      icon: <IconEnterpriseIntegrations />,
      header: "Enterprise Integrations",
      content: "Integrate and orchestrate the silo’ed internal and external systems to reduce costs and create digital sales channels"
    },
    {
      icon: <IconCloudEnablement />,
      header: "Cloud Enablement",
      content: "Create automated and cost-effective technology infrastructure on public (GCP, Azure, AWS) or private clouds"
    },
    {
      icon: <IconDigitalStrategy />,
      header: "Digital Strategy",
      content: "Discover and monetize digital opportunities with a proven strategy and battle-tested approach"
    },
    {
      icon: <IconDigitalExperiences />,
      header: "Digital Experiences",
      content: "Launch stunning and personalized shopping, service, and engagement experiences for all customers"
    },
    {
      icon: <IconDigitalTransformation />,
      header: "Digital Transformation",
      content: "Beat the competition and lead the market by transforming your business with technology, design, and data"
    }
  ]
};

export const CSSliderObj = {
  classes: "section-gap cs-sldier",
  csSliderItems: [
    {
      image: ImageCSslider1,
      imagetitle: "Reinventing Last Mile Delivery",
      imagealt: "Last mile delivery",
      category: "Logistics",
      header: (<>Reinventing last mile delivery</>),
      content: <>How we helped a manufacturing giant to optimize and automate last mile delivery & customer experiences?</>,
      link: "/work/last-mile-automation/",
    }
  ]
};


export const digitalThinkingobj = {
  classes: "digital-thinking",
  header: (<>Digital Thinking</>),
  content: (<><p>Our experts discuss strategies for navigating the supply chain landscape</p></>),
  blogGridItems: [
    { 
      width: "one-third",
      backgroundColor: "#F8F8F8",
      image: "",
      color: "black",
      category: "Strategy",
      categoryColor: "#999999",
      title: (<>Curbside Pickup – A right option for local retailers</>),
      link: "/blog/curbside-pickup-a-right-option-for-local-retailers/"
    },
    { 
      width: "one-third",
      backgroundColor: "#000000",
      image: ImageBlogImage1,
      imagealt: "Logistics Strategy",
      imagetitle: "How improving your logistics strategy will increase customer loyalty?",
      color: "white",
      category: "Strategy",
      categoryColor: "#fff",
      title: (<>How improving your logistics strategy will increase customer loyalty?</>),
      link: "/blog/improve-logistics-strategy-customer-loyalty/"
    },
    { 
      width: "one-third green-bg",
      backgroundColor: "#00D664",
      image: "",
      color: "black",
      category: "Ideas",
      categoryColor: "#333",
      title: (<>How artificial intelligence is disrupting the retail industry’s future?</>),
      link: "/blog/artificial-intelligence-disrupting-the-retai-future/"
    },
    { 
      width: "half with-img",
      backgroundColor: "transparent",
      image: ImageBlogImage2,
      imagealt: "Artificial intelligence in retail",
      imagetitle: "How artificial intelligence is disrupting the retail industry’s future?",
      color: "white",
      category: "Strategy",
      categoryColor: "#fff",
      title: (<>Roadmap for a successful supply chain digital transformation of your business logistics</>),
      link: "/blog/logistic-digital-supply-chain-roadmap/"
    },
    { 
      width: "half without-img",
      backgroundColor: "linear-gradient(0deg, #F8F8F8, #F8F8F8), #F8F8F8",
      image: "",
      color: "black",
      category: "Strategy",
      categoryColor: "#999999",
      title: (<>Curbside Pick-up: Why is it the next big thing in the retail industry?</>),
      link: "/blog/curbside-pick-up-is-next-big-thing-in-retail-industry/"
    },
    
  ],
  header1: (<>Proven results in weeks, not years.</>),
  content1: (<><p>Rapidops can transform your vision into measurable success in days and weeks with the proven approach and expertise for digital transformation.</p></>),
};